import React from "react";

function AfterContest() {
  return (
    <section id="aftercontest" className="organization-section">
      <h2>Problemas</h2>
      <div className="organization-column" width="65%">
        <p>
          <a href="pdf/miup24_problemset.pdf">
            Caderno com o conjunto de problemas
          </a>
        </p>
        <p>
          <a href="pdf/miup24_analise.pdf">
            Análise dos problemas
          </a>
        </p>
        <p>
          <a href="http://mooshak.estga.ua.pt/~miup/">Pós-MIUP</a>, se depois do
          registo não receber o email com as credenciais, por favor, contacte o{" "}
          <a href="mailto:fabio@ua.pt">Prof. Fábio Marques</a>
        </p>
      </div>
    </section>
  );
}

export default AfterContest;
